import { getGuessStatuses } from '../../lib/statuses'
import { Cell } from './Cell'
import { unicodeSplit } from '../../lib/words'
import { ChatIcon } from '@heroicons/react/outline'
import { useState } from 'react'
import { QuoteModal } from '../modals/QuoteModal'

type Props = {
  guess: string
  isRevealing?: boolean
}

export const CompletedRow = ({ guess, isRevealing }: Props) => {
  const statuses = getGuessStatuses(guess)
  const splitGuess = unicodeSplit(guess)
  const [showQuoteModal, setShowQuoteModal] = useState(false)

  return (
    <>
      <div className="flex justify-center mb-1">
        {splitGuess.map((letter, i) => (
          <Cell
            key={i}
            value={letter}
            status={statuses[i]}
            position={i}
            isRevealing={isRevealing}
            isCompleted
          />
        ))}

        <ChatIcon
          className="h-6 w-6 mr-2 cursor-pointer dark:stroke-white"
          onClick={() => setShowQuoteModal(true)}
        />
      </div>
      <QuoteModal
        isOpen={showQuoteModal}
        handleClose={() => setShowQuoteModal(false)}
        word={guess.toLowerCase()}
      />
    </>
  )
}
